import styled from 'styled-components'

import { applyIPadOnlyStyle } from 'helpers/css'
import { userTypes } from 'helpers/user'

import { getTilePosition } from '../../helper/css'

const { TEACHER, TRIBE_LEADER } = userTypes

export const Name = styled.p`
    font-family: AvenirBold;
    font-size: 10px;
    position: absolute;
    width: max-content;
    margin: -3px 0;
    ${props => {
        const { name, size } = props
        const color = [TEACHER, TRIBE_LEADER].includes(name?.toLowerCase())
            ? '#58B7E6'
            : '#313131'
        const bottom = `-${size * 0.37}px`
        return `
        color: ${color};
        bottom: ${bottom};
        `
    }}
    ${applyIPadOnlyStyle(`color: white, font-size: 8px`, {
        min: 0,
        max: 1370,
        orientation: 'both',
    })}
`

const DefaultStyle = styled.div`
    border-radius: 50%;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    ${props => {
        const { name, size } = props
        const isTeacherOrTribeLeader = [TEACHER, TRIBE_LEADER].includes(
            name?.toLowerCase()
        )
        const width = `${size}px`
        const height = `${size}px`
        const border = isTeacherOrTribeLeader ? '1px solid #58B7E6' : ''
        const background = isTeacherOrTribeLeader ? 'rgb(177,221,213)' : 'none'
        return `
            width: ${width};
            height: ${height};
            border: ${border};
            background: ${background};
        `
    }}
`

export const ParticipantTile = styled(DefaultStyle)`
    ${({ position, size }) => getTilePosition(position, size)}}
    cursor: default;
`

export const AvatarWrapper = styled.div`
    overflow: hidden;
    width: 100%;
    height: 100%;
    border-radius: inherit;
`
